document.addEventListener("DOMContentLoaded", () => {
    const videoBlock = document.querySelector(
        ".wp-block-klingit-the-product-post-video"
    );

    if (videoBlock) {
        const video = videoBlock.querySelector("video");
        const playButton = videoBlock.querySelector(".post-video-play-button");

        playButton.addEventListener("click", () => {
            playButton.remove();

            video.muted = false;
            video.currentTime = 0;
            video.play();
            video.controls = true;
        });
    }
});
